import { useQuery as r } from "react-query";
import { LoyaltyAccountAdapter as c } from "../../models/loyalty/loyaltyAccount/loyaltyAccount.adapter.js";
import { getAdapter as s } from "../../adapter.js";
import { useEnvironment as y } from "../../../common/hooks/environment/useEnvironment.js";
import { useAuth as i } from "../../../auth/hooks/useAuth.js";
function h() {
  const {
    backendBaseUrl: o
  } = y(), {
    token: n,
    customer: t
  } = i();
  return r(
    ["loyalty-account", n, t],
    async () => {
      var e;
      const u = await (await fetch(`${o}/loyalty-account/${(e = t == null ? void 0 : t.activity.loyalty) == null ? void 0 : e.code}/`, {
        method: "GET",
        headers: {
          authorization: `Token ${n}`
        }
      })).json();
      return s(c).adapt(u);
    }
  );
}
function A(o) {
  const {
    backendBaseUrl: n
  } = y();
  return r(
    ["loyalty-account", o],
    async () => {
      const a = await (await fetch(`${n}/loyalty-account/${o}/`, {
        method: "GET"
      })).json();
      return s(c).adapt(a);
    }
  );
}
export {
  h as useLoyaltyAccount,
  A as useLoyaltyAccountFromKey
};
//# sourceMappingURL=useLoyaltyAccount.js.map
